import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'


export const archivSlice = createSlice({
    name: 'archiv', //importante, ya que se realizara llamdo mas tarde por nombre
    initialState: {
        archiv: []
    },
    reducers: {
        setArchiv: (state, action) => {  //crear set
            state.archiv = action.payload
        }
    }
})


export const {  setArchiv } = archivSlice.actions

export default archivSlice.reducer



export const getArchiv = (data) => async (dispatch) => {


    try {


        return await axios
            .post(
                'https://ws.ugm.cl/api/v1_ufe/ufe_listarArchivos', data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': process.env.REACT_APP_TOKEN
                    }
                }
            )
            .then(response => {
                 //console.log('archivSlice', response.data)
                dispatch(setArchiv(response.data))

            })

    } catch (error) {

        //console.log('dispatch error', error)

    }


}